export default "__VITE_ASSET__BRvkgVmm__"